import XLSX from 'xlsx';
<template>
  <div id="app">
    <!-- <transition :name="direction"> -->
      <router-view class="page" />
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$route.name === 'glykt' ? this.$route.meta.title : '格如灵',
      meta: [
        {
          name: 'Keywords',
          content: this.$route.meta.keyWords || ''
        },
        {
          name: 'Description',
          content: this.$route.meta.description || ''
        }
      ]
    }
  },
  data() {
    return {
    };
  },
  computed: {
    // 动态设置过渡样式
    direction: function() {
      const currentPath = this.$route.path;
      const localRoute = (window.myVue && window.myVue.localRoute) || [];
      // console.log(localRoute, currentPath);
      const index = localRoute.indexOf(currentPath);
      let tranName = '';

      if (localRoute.length === 0) {
        tranName = 'fade'; // 首页，渐显
      } else if (index >= 0) {
        tranName = 'page-back'; // 回退，右划
      } else {
        tranName = 'page-go'; // 进入新页面，左划
      }
      return tranName;
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(from);
    }
  },
  created() {
    console.log('欢迎访问...');
  },
  mounted () {},
  methods: {}
};
</script>

<style lang="less">
#app {
  font-family: Microsoft Yahei, STXihei ,SourceHanSansCN-Medium, SourceHanSansCN, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: @colorFont;
  font-size: @fontSizeH3;
  font-size:26px;

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .page {
    transition: all 0.8s ease-in-out;
    min-height:100vh;
    position: relative;
  }
  .page-go-enter-active {
    transform: translate3d(100%, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-go-enter-to {
    transform: translate3d(0, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-go-leave-active {
    transform: translate3d(0, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-go-leave-to {
    transform: translate3d(-100%, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-back-enter-active {
    transform: translate3d(-100%, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-back-enter-to {
    transform: translate3d(0, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-back-leave-active {
    transform: translate3d(0, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
  .page-back-leave-to {
    transform: translate3d(100%, 0, 0);
    // transition: all 0.8s ease-in-out;
  }
}
span,div,input{
  font-size:28px;
}
#isMobile,#isMobileF{
  display: none;
}
#isPC{
  display: block;
}
#isPCF{
  display: flex;
}
.el-select-dropdown__item,.el-select-dropdown__empty{
  padding: 30px !important;
  line-height: 0px !important;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  width: 32px;
  height: 32px;
  color: #00000060;
  font-size: 12px;
  line-height: 32px;
  padding: 0;
  font-weight: normal;
  background: #fff !important;
  border-radius: 3px !important;
  border: 1px solid #DCDCDC;
}

// @font-face {
//   font-family: SourceHanSansCN;
//   src: url('./assets/fonts/bb4173.tf');
// }

@media (max-width: 1000px) {
  .page {
    padding-top: 96px;
  }
  #isMobile{
    display: block;
  }
  #isMobileF{
    display: flex;
  }
  #isPC,#isPCF{
    display: none;
  }
}

</style>
